export const ChatDateSeparator = ({ label }: { label: string }) => (
  <div className="flex items-center gap-3 py-2" role="separator">
    <div className="h-px flex-1 bg-gray-200" />
    <span className="rounded-full bg-gray-100 px-3 py-0.5 text-[10px] font-semibold text-black04">
      {label}
    </span>
    <div className="h-px flex-1 bg-gray-200" />
  </div>
)
